import React from "react";
import { Newspaper } from "lucide-react";
import TableBodyCustom from "./table.body-custom";
import DataTable from "../../../../components/data-table/DataTable";

// searching: a search is on, so "empty" means nothing matched.
const TableView = ({ newsData, TABLE_HEAD, onEditRow, searching, }) => (
  <DataTable
    head={TABLE_HEAD}
    isEmpty={!newsData?.length}
    empty={
      searching
        ? { title: "Nothing matches your search", text: "Try a different word, or clear the search." }
        : {
            icon: Newspaper,
            title: "No news yet",
            text: "News you publish shows on your website.",
          }
    }
  >
    {newsData?.map((data) => (
      <TableBodyCustom key={data?._id} data={data} onEditRow={onEditRow} />
    ))}
  </DataTable>
);

export default TableView;
